import { Component, OnDestroy, ViewChild, AfterViewInit } from '@angular/core';
import { environment } from '../../../../environments/environment';

declare const customElements: any;

@Component({
  selector: 'lfwms-tori-web-agent',
  templateUrl: './tori-web-agent.component.html',
  styleUrls: ['./tori-web-agent.component.css']
})
export class ToriWebAgentComponent implements AfterViewInit, OnDestroy {

  private readonly appId = environment.toriAppId;
  private readonly platformId = environment.toriPlatformId;
  private readonly title = environment.toriTitle;
  private readonly prompts: string | string[] = environment.toriPrompts;

  @ViewChild('toriContainer') toriContainer: any;

  private toriElement: any = null;
  private destroyed = false;

  ngAfterViewInit() {
    this.waitForCustomElementAndInit();
  }

  ngOnDestroy() {
    this.destroyed = true;
    if (this.toriElement && this.toriElement.parentNode) {
      this.toriElement.parentNode.removeChild(this.toriElement);
    }
  }

  private waitForCustomElementAndInit(): void {
    if (!this.toriContainer || this.destroyed) {
      return;
    }

    if (typeof customElements !== 'undefined' && customElements.whenDefined) {
      customElements.whenDefined('tori-web-agent').then(() => {
        if (!this.destroyed) {
          this.initializeToriAgent();
        }
      });
    } else {
      this.pollForCustomElement();
    }
  }

  private pollForCustomElement(): void {
    const maxRetries = 50;
    const retryInterval = 100;
    let retries = 0;

    const checkAndInit = () => {
      if (this.destroyed) {
        return;
      }

      if (typeof customElements !== 'undefined' && customElements.get && customElements.get('tori-web-agent')) {
        this.initializeToriAgent();
        return;
      }

      retries++;
      if (retries < maxRetries) {
        setTimeout(checkAndInit, retryInterval);
      }
    };

    checkAndInit();
  }

  private initializeToriAgent(): void {
    if (!this.toriContainer) {
      return;
    }

    if (this.toriContainer.nativeElement.querySelector('tori-web-agent')) {
      return;
    }

    this.toriElement = document.createElement('tori-web-agent');
    this.toriElement.setAttribute('app-id', this.appId);
    this.toriElement.setAttribute('platform-id', this.platformId);
    this.toriElement.setAttribute('title', this.title);

    const promptsValue = typeof this.prompts === 'string' ? this.prompts : JSON.stringify(this.prompts);
    this.toriElement.setAttribute('prompts', promptsValue);

    this.toriContainer.nativeElement.appendChild(this.toriElement);
  }
}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/components/tori-web-agent/tori-web-agent.component.ts